<template>
  <table class="table">
    <thead>
      <tr>
        <th v-for="column in columns" :key="column">{{ column }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in data" :key="item._id">
        <td>{{ item.name }}</td>
        <td>{{ returnFilteredDistance(driverDistances[item.fleet_id]) }}</td>
        <td>{{ returnFilteredTime(driverTimes[item.fleet_id]) }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  import moment from 'moment';

  export default {
    props: {
      columns: Array,
      data: Array,
      driverDistances: Object,
      driverTimes: Object,
    },
    methods: {
      returnFilteredDistance(distance) {
        try {
          if (!distance) return 0
          if (typeof distance !== 'number') throw new Error('Input is not a number');
          if (distance > 1000) return `${parseFloat((distance / 1000).toFixed(2))} km`
          else return `${parseFloat(distance).toFixed(2)} m`
        } catch (error) {
          return distance
        }
      },
      returnFilteredTime(time) {
        try {
          if (!time) return 0
          const duration = moment.duration(moment().diff(moment().subtract(time, 'seconds')));
          let formatted = "";
          if (duration.asHours() >= 1) formatted = Math.floor(duration.asHours()) + " hours " + duration.minutes() + " minutes";
          else if (duration.asMinutes() >= 1) formatted = Math.floor(duration.asMinutes()) + " minutes " + duration.seconds() + " seconds";
          else formatted = duration.seconds() + " seconds";
          return formatted;
        } catch (error) {
          return time
        }
      }
    }
  }
</script>
<style>
.link-style {
  cursor: pointer; /* Changes cursor to hand symbol */
}
</style>
